import { render } from "./HeaderFragment.vue?vue&type=template&id=195e3f52"
import script from "./HeaderFragment.vue?vue&type=script&lang=js"
export * from "./HeaderFragment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__